module.exports = __webpack_public_path__ + "img/cambio-bins.88d8ba1a.png";